import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import Page from "../../../Common/Page";
import EditSeasonFormWrapper from "../EditSeasonFormWrapper";
import NewSeasonForm from "./NewSeasonForm";

const NewSeason = () => {
  const { formatMessage } = useIntl();
  const title = useMemo(() => formatMessage({ id: "season.add" }), [formatMessage]);
  return (
    <Page title={title} tabTitle={title}>
      <EditSeasonFormWrapper>
        <NewSeasonForm />
      </EditSeasonFormWrapper>
    </Page>
  );
};

export default NewSeason;
